import React, { useMemo } from 'react';
import CardHeader from 'Components/Card/CardHeader';
import CardFooter from 'Components/Card/CardFooter';
import { CardContextProvider } from 'context/CardContext';
import styles from 'assets/css/Card.module.css';
import LoadingHandler from 'Components/LoadingWrapper';
import track from 'react-tracking';
import { formatTrackingData } from 'tracking/useUTag';
import classNames from 'classnames';
import withAttentionCard from 'Components/Card/hoc/withAttentionCard';
import withToggleCard from 'Components/Card/hoc/withToggleCard';
import * as Sentry from "@sentry/react";

function Card({className, additionalClassNames, ...props}) {
    const classes = classNames(additionalClassNames, styles.card, {
        [`${styles[className]}`]: className,
        [`${styles[props.type]}`]: props.type
    });

    //render
    return (
        <CardContextProvider type={props.type} cardTitle={props.cardTitle} draggable={props.draggable} componentName={props.componentName}>
            <div className={classes} key={props.ordinal} id={props.componentName}>
                {useMemo(() => (<CardContent {...props} />), [props])}
            </div>
        </CardContextProvider>
    )
}

function CardContent(props) {
    const CardComponent = useMemo(() => {
        try {
            return require(`./Variants/Card.${props.type}`).default; 
        } catch (error) {
            Sentry.captureException(new Error(`No Card Component exists for ${props.type}.`));
            return null;
        }
    }, [props.type]);
    
    return (
        <>
            {useMemo(() => {
                if (!CardComponent)
                    return false;
                return (<CardHeader cardTools={props.cardTools} componentName={props.componentName} type={props.type} cardIconKey={props.cardIconKey} cardTitle={props.cardTitle} draggable={props.draggable} />)
            }, [CardComponent, props.cardTitle, props.cardTools, props.type, props.componentName, props.draggable, props.cardIconKey])}
            {useMemo(() => {
                if (!CardComponent)
                    return false;

                const queryOpts = {};
                if (props.staleTime || props.staleTime === 0) {
                    queryOpts.staleTime = props.staleTime;
                }
                return (
                    <div className={styles.cardBodyContent}>
                        <LoadingHandler retrievalUrl={props.retrievalUrl} componentName={props.componentName} queryOpts={queryOpts}>
                            {(data) => (
                                <>
                                    <CardComponent data={data} cardToolsSubheader={props.cardToolsSubheader}/>
                                    <CardFooter data={data} />
                                </>
                            )}
                        </LoadingHandler>
                    </div>
                );
            }, [CardComponent, props.retrievalUrl, props.componentName, props.staleTime])}
        </>
    );
}

const TrackedCard = track(({ type, componentName }) => formatTrackingData({ card: type, component: componentName }))(Card);
const ToggleCard = withToggleCard(TrackedCard);
const AttentionCard = withAttentionCard(ToggleCard);

export default AttentionCard;
